import React from 'react';
import PropTypes from 'prop-types';
import { RECAPTCHA_SITE_KEY } from '../../../utils/constants';
import Script from 'next/script';

const ReCaptchaGoogle = ({ nonce }) => {
  return (
    <Script
      src={'https://www.google.com/recaptcha/enterprise.js?render=' + RECAPTCHA_SITE_KEY}
      nonce={nonce}
    />
  );
};

ReCaptchaGoogle.propTypes = {
  nonce: PropTypes.string,
};

export default ReCaptchaGoogle;
